import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { ClientTariffsPage } from '@/pages/client-tariffs/ClientTariffsPage'

export const Route = createFileRoute('/legal-entity-tariffs')({
  component: () => (
    <RequirePermission section="clientTariffs" action="view">
      <ClientTariffsPage />
    </RequirePermission>
  ),
})
